module.exports = __webpack_public_path__ + "../resources/img/ic_re_no3_p2_line_wh.e442ed13.svg";